export default "__VITE_PUBLIC_ASSET__22c91bf5__"